module.exports = __webpack_public_path__ + "static/media/black-arrow-down.4ce4ce51.svg";